module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/buy-property.505a2b70bd8c16aa6cbd332e942a7378.jpg";